import React from 'react'
import { View, StyleSheet, Text } from 'react-native'
import RootStore from '../../../../store'
import { observer } from 'mobx-react'
import { BankConnectionType } from '@linqpal/models/src/dictionaries'
import { BtText } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { useResponsive } from '@linqpal/components/src/hooks'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

export const DisconnectedList = observer(() => {
  const { sm } = useResponsive()
  const { onlineConnectedBanks } = RootStore.screensStore.paymentMethodsStore
  const disconnected = onlineConnectedBanks.filter(
    (b) => b.connectionType === BankConnectionType.FINICITY,
  )
  return (
    <View
      style={{
        marginTop: 25,
        flexDirection: sm ? 'row' : 'column',
        justifyContent: 'space-between',
      }}
      testID={'disconnected-bank-accounts-list'}
    >
      {disconnected.map((b) => (
        <DisconnectedItem bank={b} />
      ))}
    </View>
  )
})

const DisconnectedItem = ({ bank }) => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()
  const { getAccTypeAndNumber } = RootStore.screensStore.paymentMethodsStore
  const widthInStyle = sm ? { width: 216 } : { minWidth: 216 }

  return (
    <View
      style={composeStyle({ height: 91 }, widthInStyle)}
      testID={'disconnected-bank-item'}
    >
      <Badge />
      <View style={composeStyle(styles.itemContainer, widthInStyle)}>
        <Text style={styles.itemName}>{bank.name}</Text>
        <Text style={styles.itemName2}>
          {getAccTypeAndNumber(bank.accountType, bank.accountNumber, t)}
        </Text>
      </View>
    </View>
  )
}

export const Badge = () => {
  const { t } = useTranslation('global')
  return (
    <View style={styles.badge}>
      <BtText style={styles.text}>
        {t('ConnectBankWithPlaid.disconnected-badge')}
      </BtText>
    </View>
  )
}

const styles = StyleSheet.create({
  itemContainer: {
    height: 80,
    backgroundColor: '#FFE8E8',
    borderWidth: 0,
    borderRadius: 8,
    marginTop: 10,
    paddingHorizontal: 20,
    paddingVertical: 20,
  },
  text: {
    fontWeight: '500',
    fontSize: 12,
    color: 'white',
    lineHeight: 20,
  },
  badge: {
    height: 22,
    maxWidth: 210,
    position: 'absolute',
    top: 0,
    right: 10,
    zIndex: 1,
    borderRadius: 5,
    paddingHorizontal: 8,
    flex: 2,
    backgroundColor: '#DB2424',
  },
  itemName: {
    fontWeight: '500',
    fontSize: 16,
    color: '#335C75',
    marginBottom: 5,
  },
  itemName2: {
    fontWeight: '500',
    fontSize: 12,
    color: '#668598',
  },
})
